module.exports = __webpack_public_path__ + "img/connected.81b49537.svg";